import {Directive, HostListener, input} from '@angular/core';

@Directive({
  selector: 'input[uppercase]'
})
export class UppercaseDirective {
  readonly uppercase = input<boolean>(true);

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (!this.uppercase()) return;

    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = input.value.toUpperCase();
    input.setSelectionRange(start, end);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (!this.uppercase()) return;

    const input = event.target as HTMLInputElement;

    setTimeout(() => {
      const start = input.selectionStart;
      input.value = input.value.toUpperCase();
      input.setSelectionRange(start, start);
      input.dispatchEvent(new Event('input', {bubbles: true}));
    }, 0);
  }
}
